import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, brandSecondary, header, mention, nameCircles } from '../../../web/styles/colors';
import { Layouts } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	dragContainer: {
		alignItems: 'center',
		background: mention,
		border: `2px dashed rgba(0,170,232, 1)`,
		borderRadius: 6,
		boxShadow: '0px 0px 6px rgba(139,139,139, 0.100034)',
		cursor: 'pointer',
		height: 198,
		opacity: 1,
		textAlign: 'center',
		width: 500,
	},
	dragContainerHover: {
		alignItems: 'center',
		background: mention,
		border: `4px dashed rgba(0,170,232, 1)`,
		borderRadius: 6,
		boxShadow: '0px 0px 6px rgba(139,139,139, 0.100034)',
		boxSize: 'border-box',
		cursor: 'pointer',
		height: 198,
		opacity: 1,
		textAlign: 'center',
		width: 500,
	},
	header: {
		display: 'flex',
		columnGap: '12px',
		justifyContent: 'space-between',
	},
	footer: {
		display: 'flex',
		columnGap: '12px',
		marginTop: 24,
	},
	logoImage: {
		maxWidth: 41,
		padding: '10px 0px 10px 5px',
	},
	logoName: {
		marginRight: 74,
	},
	logoRemove: {
		marginRight: 12,
		transform: 'translateY(-2px)',
	},
	logoWrap: {
		...Layouts.horizontalStack(12),
		border: `1px solid ${nameCircles}`,
		borderRadius: 3,
		boxShadow: '0px 0px 6px rgba(139,139,139, 0.100034)',
	},
	nameInput: {
		marginBottom: 8,
	},
	nameLabel: {
		marginBottom: 4,
	},
	noMargin: {
		margin: 0,
	},
	previewImage: {
		position: 'absolute',
		margin: 'auto',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		maxHeight: '100%',
		maxWidth: '100%',
	},
	previewImageWrap: {
		background: '#fff',
		border: `1px solid ${nameCircles}`,
		borderRadius: 3,
		position: 'relative',
		width: 700,
		height: 500,
	},
	resizeImageContainer: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 'auto',
		width: '50%',
	},
	resizeImageSlider: {},
	uploadButton: {
		color: brandPrimaryText,
	},
	uploadModalDescription: {
		color: brandSecondary,
		fontSize: 12,
	},
	uploadModalInnerWrap: {
		padding: '38px 0',
	},
	uploadModalRecommendation: {
		color: header,
		fontSize: 12,
		margin: '0 0 12px',
		textAlign: 'right',
	},
	uploadModalSubTitle: {
		color: brandPrimaryText,
		fontSize: 18,
		margin: 0,
	},
	uploadModalTitle: {
		color: brandPrimaryText,
		fontSize: 24,
		margin: 0,
	},
});
